<!--
 * @Author: The_xu 2596841393@qq.com
 * @Date: 2025-04-03 13:02:40
 * @LastEditors: The_xu 2596841393@qq.com
 * @LastEditTime: 2025-04-10 18:20:42
 * @FilePath: /yda-qywx-h5/src/components/head/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div
    :style="{
      background: getHeadBackground,
      zIndex: headZIndex
    }"
    :class="[headFixed ? 'special_box' : '', 'head_box']"
  >
    <div class="back-box" @click="goBack" v-if="getBackBtShow">
      <i
        class="iconfont icon-biaotilan-fanhui back"
        :style="{ color: getHeadColor }"
      ></i>
    </div>
    <span :style="{ color: getHeadColor }">{{
      ['相机页', '补拍'].includes(getHeadContent) ? '' : getHeadContent
    }}</span>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed, inject, watch, ref } from 'vue'
import { useHeadStore, HEAD_EVENT_TYPE } from '@/store/home'
const headStore = useHeadStore()
const route = useRoute()
// 获取头部标题内容
// const getHeadContent = computed(() => {
//   console.log(route.meta.title, '909090909')
//   return route.meta.title ?? ''
// })
const getHeadContent = ref(route.meta.title ?? '')

const customHeadColor = ref('')
const customHeadBackground = ref('')

// 获取背景色
const getHeadBackground = computed(() => {
  if (route.meta.customHead) {
    return customHeadBackground.value
  } else {
    return getHeadContent.value === '相机页'
      ? 'transparent'
      : route.meta.background ?? 'white'
  }
})
// 获取字体颜色
const getHeadColor = computed(() => {
  if (route.meta.customHead) {
    return customHeadColor.value
  } else {
    return getHeadContent.value === '相机页'
      ? '#ffffff'
      : route.meta.color ?? '#000000'
  }
})
// 返回按钮是否展示
const getBackBtShow = computed(() => {
  return !route.meta.backHidden
})
// 获取注入的返回方法
const executeGoBack = inject('executeGoBack')
// 返回方法执行
const goBack = () => {
  executeGoBack()
}

const headFixed = computed(() => {
  return route.meta.headFixed ?? false
})

watch(
  () => route.name,
  () => {
    console.log('newMeta', route.meta)
    if (route.meta.title) {
      console.log('newMeta', route.meta.title)
      getHeadContent.value = route.meta.title
      Object.defineProperty(route.meta, `title`, {
        set(newVal) {
          getHeadContent.value = newVal
        }
      })
    }
  },
  {
    immediate: true,
    deep: true
  }
)

const headZIndex = computed(() => headStore.zIndex)

headStore.addEventListener(HEAD_EVENT_TYPE.SET_HEAD_COLOR, (newVal) => {
  if (newVal) {
    console.log('newValAll', newVal)
    customHeadColor.value = newVal.headColor
    customHeadBackground.value = newVal.headBackground
  }
})
</script>

<style lang="less" scoped>
// 头部标题盒子
.head_box {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  // z-index: 2147483647;

  .mixin-custom-style-safe(@paddingTop, @dynamicPaddingTop, 0rem);

  box-sizing: content-box;

  .back-box {
    position: absolute;
    left: 18px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .back {
      font-size: 22px;
      color: #131314;
    }
  }

  span {
    font-weight: 500;
    font-size: 17px;
    line-height: 24px;
  }
}

.special_box {
  position: fixed;
  z-index: 999;
}
</style>
